document.addEventListener("DOMContentLoaded", function () {
  const swiperContainer = document.querySelector(".industry-form-industries__swiper");

  const industrySwiper = new Swiper(".industry-form-industries__swiper", {
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: false,
    watchOverflow: true,
    loop: false,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".industry-form-industries__pagination",
      type: "progressbar"
    },
    breakpoints: {
      769: {
        pagination: false // Disable progress bar on tablet and up
      },
      768: {
        spaceBetween: 16
      },
      480: {
        spaceBetween: 12
      }
    },
    on: {
      afterInit: function () {
        updateNavVisibility(this);
      },
      slideChange: function () {
        updateNavVisibility(this);
      },
      resize: function () {
        updateNavVisibility(this);
      },
      reachEnd: function () {
        updateNavVisibility(this);
      },
      reachBeginning: function () {
        updateNavVisibility(this);
      }
    }
  });

  function updateNavVisibility(swiper) {
    const container = swiperContainer.parentElement;
    const prevBtn = container.querySelector(".swiper-button-prev");
    const nextBtn = container.querySelector(".swiper-button-next");

    if (!prevBtn || !nextBtn) return;

    if (swiper.isBeginning) {
      prevBtn.classList.add("swiper-button-disabled");
    } else {
      prevBtn.classList.remove("swiper-button-disabled");
    }

    if (swiper.isEnd) {
      nextBtn.classList.add("swiper-button-disabled");
    } else {
      nextBtn.classList.remove("swiper-button-disabled");
    }
  }
});
